import { callBackendApi } from "src/components/service/axios";

export const getSystemResourceTypes = async () => {
  return await callBackendApi("get", "/bff/system-resource-types");
};

export const getCurrentAccessControlsBasedOnSystemResource = async (requestBody,config) => {
  return await callBackendApi(
    "post",
    "/bff/current-access-visibility/system-resource/search",
    requestBody,
    null,
    true,
    config
  );
};

export const getCurrentAccessControlsBasedOnInformationAssets = async (requestBody,config) => {
  return await callBackendApi(
    "post",
    "/bff/current-access-visibility/information-assets/search",
    requestBody,
    null,
    true,
    config
  );
};
